/**
 * Checks if a given date is in the past.
 * @param date A date string or null
 * @returns true if the date is in the past, false otherwise
 */
export const isDateInPast = (date: string | null): boolean => {
  if (!date) return false;

  const inputDate = new Date(date);

  const todayDate = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
  const today = new Date(todayDate);

  // Normalize both dates to midnight
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return inputDate < today;
};
